import { render } from "./SearchPopupComponent.vue?vue&type=template&id=b029f6ac&scoped=true"
import script from "./SearchPopupComponent.vue?vue&type=script&lang=js"
export * from "./SearchPopupComponent.vue?vue&type=script&lang=js"

import "./SearchPopupComponent.vue?vue&type=style&index=0&id=b029f6ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b029f6ac"]])

export default __exports__